export const GITLAB_DEFAULT_MODEL = '';
export const SUPPRESS_DEFAULT_MODEL_MODAL_KEY = 'suppress_default_model_modal';
